module.exports = __webpack_public_path__ + "img/pure white holy night.800b85f8.png";